import styled from 'styled-components'

export const StyledLonDashboard = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  background: ${({ theme }) => theme.colors.bgBase};

  .lon-dashboard-inner {
    width: 1220px;
    background: #ffffff;
    border: 0.714878px solid #e1e6ea;
    box-shadow: 0px 4.28927px 5.71902px rgba(29, 115, 232, 0.05);
    backdrop-filter: blur(19.4324px);
    border-radius: 20px;
    margin: 0 0 -70px 0;
    position: relative;
    top: -70px;
    padding: 65px 74px 31px 84px;
    box-sizing: border-box;
  }

  .lon-data-number {
    font-style: normal;
    font-weight: bold;
    font-size: 32px;
    line-height: 38px;
    letter-spacing: 0.242857px;
    mix-blend-mode: normal;
  }

  .lon-dashboard-overview {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .lon-dashboard-distribute-data-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .lon-dashboard-distribute-data {
      width: 545px;
      height: 245px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }

  .division {
    width: 100%;
    font-style: normal;
    font-weight: normal;
    font-size: 17px;
    line-height: 25px;
    text-align: center;
    color: ${({ theme }) => theme.colors.textTertiary};
    margin: 21px 0 48px 0;
    display: flex;
    align-items: center;
    white-space: nowrap;

    &::before {
      content: '';
      display: block;
      width: 427px;
      height: 1px;
      background: #e1e6ea;
      margin-right: 70px;
    }

    &::after {
      content: '';
      display: block;
      width: 427px;
      height: 1px;
      background: #e1e6ea;
      margin-left: 70px;
    }
  }
  .data-item-wrapper {
    .data-item-title-wrapper {
      display: flex;
      align-items: center;
    }
    .data-item-title {
      font-style: normal;
      font-weight: 500;
      font-size: 17px;
      line-height: 24px;
      letter-spacing: 0.5px;
      mix-blend-mode: normal;
      opacity: 0.6;
    }

    .data-item-body {
      margin-top: 10px;
    }

    .primary-circle {
      width: 7px;
      height: 7px;
      border: 2px solid;
      border-radius: 50%;
      margin-right: 8px;
    }
  }
  .data-item-body-text {
    width: 419px;
    color: #6f6295;
    font-style: normal;
    font-weight: bold;
    font-size: 17px;
    line-height: 25px;
  }
  @media screen and (max-width: 640px) {
    justify-content: flex-start;
    .lon-dashboard-inner {
      width: 90%;
      height: auto;
      padding: 47px 40px 56px 40px;
      margin: auto;
    }
    .lon-dashboard-overview {
      flex-wrap: wrap;
      margin-top: -27px;
    }

    .division {
      margin-top: 38px !important;
      margin-bottom: 0 !important;
    }

    .data-item-wrapper {
      margin: 27px 20px 0 0;
    }

    .lon-dashboard-distribute-data-wrapper {
      flex-wrap: wrap;
      justify-content: center !important;

      .distribute-data-img {
        display: block;
        margin: 45px auto 0 auto !important;
      }

      .lon-dashboard-distribute-data {
        justify-content: flex-start !important;
        width: auto !important;
        height: auto !important;
      }
    }

    .data-item-body-text {
      width: auto;
    }
  }
`
